// Sai Maheshwar 01/12/2022 2701306337 ,2701326866  added search component
// Sai Maheshwar 01/12/2022 2701306337 ,2701326866  add intermediate repo field API integration
// kavyareddy 01/13/2023 2701306337 ,2701326866 Added createdBy field
// kavyareddy 01/13/2023 2701306337 ,2701326866 Added newRepositoryName field
// Sohel 01/13/2023 2698964415 added populate data
// Suresh Peddavoora 01/14/2023 2698964415 Fixed Text Fields, Buttons Alignments
// Suresh Peddavoora 01/16/2023 2698964415 Fixed Responsive issue for buttons
// sai krishna 02/02/2023 2698964415 added repositoryType field
// Ashraf 02/02/2023 2698964415 fixed reset issue
// Dilip 02/09/2023 2698964415 added created by dropdown
// suresh peddavoora 02/21/2023 2698964415 table and textfields alignments
// suresh peddavoora 02/21/2023 2698964415 Button alignments alignments
// suresh peddavoora 02/27/2023 2698964415 New UI changes
// Rohini 02/28/2023 2698964415 added the row for the buttons
// suresh peddavoora 03/01/2023 2698964415 Button alignment fixes
// Rohini 03/01/2023 2698964415 worked on the button enhancements
// Raghu 03/14/2023 2698964415 fixed alignemnts in responsive
// Prakash 03/16/2023 2698964415 fixed ui bugs in responsive.
// Prakash 03/16/2023 2698964415 fixed alignments issue .
// Akhila 06/08/2023 2698964415 created date change to date created field and column

import React, {useEffect, useState, useContext, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
  getFieldType,
} from '../../../redux/reducers/GlobalField/AddFieldList';
import {Button, TextField, FormHelperText} from '@material-ui/core';
import {Form, Formik} from 'formik';
import ErrorBoundaryForComponents from '../../../util/ErrorBoundaryForComponents';
import {ThemeContext} from '../../../themes/ThemeProvider';
import {
  ErrorSnackbar,
  SuccessSnackbar,
} from '../../../components/CustomSnackBar';
import * as Yup from 'yup';
import {
  getAllReportCreatedForData,
  fetchCreatedByDropDownData,
} from '../../../redux/reducers/ReportMaster';
import DateFnsUtils from '@date-io/date-fns';
import {MuiPickersUtilsProvider, KeyboardDatePicker} from '@material-ui/pickers';
import GuiAutoComplete from '../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../components/FormComponents/GuiTextField';
import IntermediateRepoSearchTable from './IntermediateRepoSearchTable';
import DialogBox from '../../../components/DialogBox';
import AddFieldForm from './AddFieldForm';
import PageLoader from '../../../components/PageLoader';
import {filteredCheckedData, tempSelectFunc} from '../../../util/Functions';
import {createdByOptions} from '../../../util/CreatedByForOptions';

const SearchIntermediateRepo = ({
  mapFields,
  isDataManager,
  tempSelectedRows,
  handleDialogClose,
  setTempSelectedRows,
  setDMFieldValue,
  dmValues,
  dmArrayHelpers,
  deletedIds,
  setDeletedIds,
  recordType,
  isProcessorFieldsMap,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState(false);
  const dispatch = useDispatch();
  const {fieldTypeData} = useSelector(({addFieldList}) => addFieldList);
  const {loading, errorMsg, successMsg} = useSelector(({intermediateRepo}) => intermediateRepo);
  const {createdByData} = useSelector(({reportMaster}) => reportMaster);
  const tempUnCheckedRef = useRef([]);

  const repositoryNames = [
    {repoTypeCode: 'U', repoTypeName: 'USER'},
    {repoTypeCode: 'S', repoTypeName: 'SYSTEM'},
  ];
  const validationSchema = Yup.object().shape({
    createdDate: Yup.date().typeError('Invalid date format').nullable(),
  });
  useEffect(() => {
    dispatch(getFieldType());
  }, []);

  useEffect(() => {
    dispatch(fetchCreatedByDropDownData('stagingrepository'));
  }, [dispatch]);

  useEffect(() => {
    dispatch(getAllReportCreatedForData());
  }, []);
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleSubmit = (values) => {
    setSearchData(values);
    setSubmit(true);
  };
  useEffect(() => {
    setSearchData({
      ...searchData,
      type:
        recordType?.value === 'New Payment Import' ?
          'New Payment' :
          recordType?.value === 'New Account Import' ?
            'New Account' :
            '',
    });
  }, [isDataManager, recordType]);
  const onClear = () => {
    const data = {
      type:
        isDataManager && recordType?.value === 'New Payment Import' ?
          'New Payment' :
          recordType?.value === 'New Account Import' ?
            'New Account' :
            '',
      repostoryName: '',
      fieldName: '',
      newFieldName: '',
      fieldType: '',
      nbRepoName: '',
      createdBy: '',
      repoType: '',
      createdDate: null,
    };
    setSearchData(data);
  };

  return (
    <div className={isDataManager ? `col-12` : ``}>
      <h2 className="search-title">Repository Search</h2>
      <Formik
        onSubmit={handleSubmit}
        initialValues={{
          type:
            isDataManager && recordType?.value === 'New Payment Import' ?
              'New Payment' :
              recordType?.value === 'New Account Import' ?
                'New Account' :
                '',
          repostoryName: '',
          fieldName: '',
          newFieldName: '',
          fieldType: '',
          nbRepoName: '',
          repoType: '',
          createdDate: null,
          createdBy: '',
        }}
        enableReinitialize
        validationSchema={validationSchema}
      >
        {(props) => {
          const {values, handleChange, handleReset, handleBlur, setFieldValue, touched, errors} =
            props;

          return (
            <Form autoComplete="off">
              <ErrorBoundaryForComponents>
                <div className="form-row  standard-field-textfields new-standard-textfields">
                  <div className="col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-2 form-group">
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="type"
                      id="type"
                      size="small"
                      value={values.type}
                      disabled={isDataManager}
                      options={['New Account', 'New Payment']}
                      onChange={(e, value) => {
                        setFieldValue('type', value);
                      }}
                      placeholder="Select Type"
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            className={`${classes.labelName}`}
                            {...params}
                            variant="outlined"
                            margin="dense"
                            name="type"
                            label="Type"
                            // placeholder="Select Base Category"
                          />
                        </div>
                      )}
                    />
                  </div>

                  <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-4`}>
                    <TextField
                      margin="dense"
                      className={`${classes.labelName}`}
                      variant="outlined"
                      placeholder={`Enter New Repository Name`}
                      label="New Repository Name"
                      name="nbRepoName"
                      value={values?.nbRepoName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fullWidth
                      touched={touched.nbRepoName}
                    />
                  </div>

                  <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3`}>
                    <TextField
                      margin="dense"
                      className={`${classes.labelName}`}
                      variant="outlined"
                      placeholder={`Enter New Field Name`}
                      label="New Field Name"
                      name="newFieldName"
                      value={values?.newFieldName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fullWidth
                      touched={touched.newFieldName}
                    />
                  </div>

                  <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3 form-group`}>
                    <TextField
                      margin="dense"
                      className={`${classes.labelName}`}
                      variant="outlined"
                      placeholder={`Enter Repository Name`}
                      label="Repository Name"
                      name="repostoryName"
                      value={values?.repostoryName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fullWidth
                      touched={touched.repostoryName}
                    />
                  </div>
                  <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-2`}>
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="repoType"
                      id="repoType"
                      size="small"
                      // disabled={category}
                      value={values.repoType}
                      options={repositoryNames}
                      autoHighlight
                      getOptionDisabled={(option) => option.repoTypeCode === ''}
                      getOptionLabel={(option) => {
                        return option && option.repoTypeName ?
                          option.repoTypeCode === null ?
                            option.repoTypeName :
                            option.repoTypeCode + ' - ' + option.repoTypeName :
                          '';
                      }}
                      onChange={(e, value) => {
                        setFieldValue('repoType', value);
                      }}
                      placeholder="Select Repo Type"
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            className={`${classes.labelName}`}
                            {...params}
                            variant="outlined"
                            margin="dense"
                            name="repoType"
                            label="Repository Type"
                            placeholder="Select Repo Type"
                          />
                        </div>
                      )}
                    />
                  </div>
                  <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-2`}>
                    <TextField
                      margin="dense"
                      className={`${classes.labelName}`}
                      variant="outlined"
                      placeholder={`Enter Field Name`}
                      label="Field Name"
                      name="fieldName"
                      value={values?.fieldName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fullWidth
                      touched={touched.fieldName}
                    />
                  </div>
                  <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2 form-group">
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="fieldType"
                      id="fieldType"
                      size="small"
                      value={values.fieldType}
                      options={fieldTypeData || []}
                      onChange={(e, value) => {
                        setFieldValue('fieldType', value);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            className={`${classes.labelName}`}
                            {...params}
                            variant="outlined"
                            margin="dense"
                            label="Field Type"
                            placeholder="Select Field Type"
                          />
                        </div>
                      )}
                    />
                  </div>
                  <div className="col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group">
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="createdBy"
                      id="createdBy"
                      size="small"
                      value={values.createdBy}
                      options={createdByData}
                      getOptionLabel={(option) => {
                        return option && option?.userLoginName ? option?.userLoginName : '';
                      }}
                      renderOption={(option) => {
                        return createdByOptions(option);
                      }}
                      onChange={(e, value) => {
                        setFieldValue('createdBy', value);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            className={`${classes.labelName}`}
                            {...params}
                            variant="outlined"
                            margin="dense"
                            label="Created By"
                            placeholder="Select Created By"
                          />
                        </div>
                      )}
                    />
                  </div>
                  <div className="col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group">
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        className={`${classes.labelName}`}
                        format="MM/dd/yyyy"
                        placeholder="MM/DD/YYYY"
                        fullWidth
                        value={values.createdDate}
                        name="createdDate"
                        onBlur={handleBlur}
                        inputVariant="outlined"
                        helperText=""
                        label="Date Created"
                        onChange={(val) => {
                          setFieldValue('createdDate', val);
                        }}
                        autoOk
                        margin="dense"
                        error={Boolean(touched?.createdDate && errors?.createdDate)}
                      />
                    </MuiPickersUtilsProvider>

                    <FormHelperText variant="outlined">
                      {touched.createdDate && errors.createdDate ? errors.createdDate : ''}
                    </FormHelperText>
                  </div>
                  {!mapFields ? (
                    <div className="col-md-12 col-lg-3 col-xl-12 form-group">
                      <div className=" d-flex justify-content-center">
                        <Button
                          variant="outlined"
                          className={`mr-1 reset-btn`}
                          onClick={() => {
                            handleReset();
                            setSubmit(true);
                            onClear();
                          }}
                        >
                          Reset
                        </Button>
                        <Button type="submit" variant="outlined" className={`ml-1 search-btn`}>
                          Search
                        </Button>
                      </div>
                    </div>
                  ) : null}
                </div>

                {mapFields ? (
                  <div className="form-row">
                    <div className="col-md-6 col-lg-7">
                      <div className=" d-flex justify-content-md-center justify-content-lg-end">
                        <Button
                          variant="outlined"
                          className={`mr-1 reset-btn`}
                          onClick={() => {
                            handleReset();
                            setSubmit(true);
                            onClear();
                          }}
                        >
                          Reset
                        </Button>
                        <Button type="submit" variant="outlined" className={`ml-1 search-btn`}>
                          Search
                        </Button>
                      </div>
                    </div>
                    <div className={`col-md-6 col-lg-5`}>
                      <div className="d-flex justify-content-md-end">
                        <Button
                          aria-label="close"
                          variant="outlined"
                          className={`mr-1 reset-btn ${classes.buttonRoot}`}
                          onClick={() => {
                            handleDialogClose();
                          }}
                        >
                          Close
                        </Button>
                        <Button
                          aria-label="save"
                          variant="outlined"
                          className={`ml-1 search-btn ${classes.buttonRoot}`}
                          onClick={() => {
                            const obj = tempSelectFunc(
                              'nbRepoName',
                              'nbFieldName',
                              tempUnCheckedRef,
                            );
                            if (isDataManager && dmValues) {
                              if (isProcessorFieldsMap) {
                                const [newSelectedRows] = filteredCheckedData(
                                  dmValues.selectedFields,
                                  obj,
                                  'repositoryName',
                                  'fieldName',
                                );
                                const allSelectedRows = [...newSelectedRows, ...tempSelectedRows];
                                setDMFieldValue('selectedFields', allSelectedRows);
                              } else {
                                const [newSelectedRows, newUnSelectedRows] = filteredCheckedData(
                                  dmValues.selectedFields,
                                  obj,
                                  'repositoryName',
                                  'fieldName',
                                );
                                const allSelectedRows = [...newSelectedRows, ...tempSelectedRows];
                                setDMFieldValue('selectedFields', allSelectedRows);
                                if (newUnSelectedRows.length > 0) {
                                  const allDeleteIds = [];
                                  newUnSelectedRows.forEach((el) => {
                                    if (el.dataManagerRecordFieldId) {
                                      allDeleteIds.push(el.dataManagerRecordFieldId);
                                    }
                                  });

                                  const ids = [...deletedIds, ...allDeleteIds];
                                  setDeletedIds(ids);
                                }
                              }
                            }
                            setTempSelectedRows([]);
                            handleDialogClose();
                          }}
                        >
                          Save
                        </Button>
                      </div>
                    </div>
                  </div>
                ) : null}
                <DialogBox
                  open={open}
                  dialogClose={handleClose}
                  title="Add Field"
                  fullWidth
                  maxWidth={'lg'}
                  classes={{paper: classes.dialogPaper}}
                >
                  <AddFieldForm handleClose={handleClose} />
                </DialogBox>
              </ErrorBoundaryForComponents>
            </Form>
          );
        }}
      </Formik>

      <IntermediateRepoSearchTable
        searchData={searchData}
        submit={submit}
        setSubmit={setSubmit}
        setOpen={setOpen}
        mapFields={mapFields}
        isDataManager={isDataManager}
        tempSelectedRows={tempSelectedRows}
        handleDialogClose={handleClose}
        setTempSelectedRows={setTempSelectedRows}
        setDMFieldValue={setDMFieldValue}
        dmValues={dmValues}
        dmArrayHelpers={dmArrayHelpers}
        deletedIds={deletedIds}
        setDeletedIds={setDeletedIds}
        tempUnCheckedRef={tempUnCheckedRef}
        isProcessorFieldsMap={isProcessorFieldsMap}
      />
      {loading && <PageLoader />}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </div>
  );
};

export default SearchIntermediateRepo;
